import axios from "axios";
import history from "router/history";
import { handleError } from "utils";

import {
  osVersion,
  osName,
  browserVersion,
  browserName,
} from "react-device-detect";

import { loadAppStuff } from "components/feature/app/actions";
import { useSelector } from "react-redux";

import { placeBet } from "../../contest/actions";

export const CHECK_LOGIN = "login:CHECK_LOGIN";
export const CLEAR_LOGIN = "login:CLEAR_LOGIN";
export const SET_IS_LOGGING_IN = "login:SET_IS_LOGGING_IN";
export const SET_GDPR_ACCEPTED = "login:SET_GDPR_ACCEPTED";

export function setIsLoggingIn(val) {
  return {
    type: SET_IS_LOGGING_IN,
    payload: val,
  };
}

export function setGdprAccepted(val) {
  return {
    type: SET_GDPR_ACCEPTED,
    payload: val,
  };
}

export const checkLogin = (username, password, userBetData) => (dispatch, getState) => {
  localStorage.removeItem("fiver_react_access_token");
  delete axios.defaults.headers.common["Authorization"];

  dispatch(setIsLoggingIn(true));
  axios
    .post(`/auth/login`, { username, password })
    .then(({ data }) => {
      const currentDate = new Date().toLocaleString();
      const { access_token, refresh_token } = data;
      localStorage.setItem("fiver_react_access_token", access_token);
      localStorage.setItem("fiver_react_refresh_token", refresh_token);

      axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;

      dispatch({
        type: CHECK_LOGIN,
        payload: { loginSuccess: undefined },
      });

      axios
        .get(`/me`)
        .then(({ data }) => {
          const profile = data.data;

          dispatch(loadAppStuff(profile));

          if (profile.gdprAccepted) {
            dispatch(setIsLoggingIn(undefined));
            dispatch(setGdprAccepted(true));
            localStorage.removeItem("fiver_react_gdpr_required");

            const dateArray = profile.birthDate.split("-");

            window.xtremepush(
              "event",
              "LandingPage.Login",
              JSON.stringify({
                AppName: process.env.REACT_APP_TITLE,
              })
            );

            window.xtremepush("set", "user_id", profile.id);

            window.xtremepush("user", "update", {
              user_id: profile.id,
              email: profile.email,
              mobile_number: profile.mobileNumber,
              first_name: profile.firstName,
              last_name: profile.lastName,
              birth_date: profile.birthDate,
              tenant_id: process.env.REACT_APP_TENANT,
              username: profile.username,
              sms_subscription:
                profile.contactPermissions.smsNotificationsAccepted,
              email_subscription:
                profile.contactPermissions.emailNotificationsAccepted,
              push_subscription:
                profile.contactPermissions.inAppNotificationsAccepted,
            });

            if (window?.webkit?.messageHandlers?.appInterface) {
              window.webkit.messageHandlers.appInterface.postMessage(
                JSON.stringify({
                  profileId: profile.id,
                })
              );
            }

            if (window?.appInterface) {
              window.appInterface.postMessage(
                JSON.stringify({
                  profileId: profile.id,
                })
              );
            }

            history.push("/");
          } else {
            dispatch(setGdprAccepted(false));
          }
        })
        .catch(({ response }) => {
          handleError(response);
        });

      if (userBetData) {
        dispatch(placeBet(userBetData?.activePickem?.id, userBetData?.picks, userBetData?.activePickem?.name, userBetData?.tiebreaker))
      }
    })
    .catch(({ response }) => {
      dispatch(setIsLoggingIn(undefined));
      localStorage.removeItem("fiver_react_access_token");
      if (
        response?.data?.code === "userIsSelfExcluded" ||
        response?.data?.code === "userNeedsToBeReactivated" ||
        response?.data?.code === "userDisabled"
      ) {
        dispatch({
          type: CHECK_LOGIN,
          payload: { loginSuccess: false, loginError: response?.data?.message },
        });
      } else {
        dispatch({
          type: CHECK_LOGIN,
          payload: {
            loginSuccess: false,
            loginError: "Invalid username or password",
          },
        });
      }
    });
};

export function clearLogin() {
  return {
    type: CLEAR_LOGIN,
    payload: undefined,
  };
}

export const updateGdpr = (params) => (dispatch) => {
  axios
    .get(`/me?include=address`)
    .then(({ data }) => {
      const profile = data.data;

      profile.contactPermissions = params;
      profile.gdprAccepted = true;

      axios
        .put(`/me`, profile)
        .then(({ data }) => {
          localStorage.removeItem("fiver_react_gdpr_required");
          history.push("/");
        })
        .catch(({ response }) => {
          handleError(response);
        });
    })
    .catch(({ response }) => {
      handleError(response);
    });
};
